import { render, staticRenderFns } from "./SettingsRoles.vue?vue&type=template&id=314b5b26&scoped=true"
import script from "./SettingsRoles.vue?vue&type=script&lang=js"
export * from "./SettingsRoles.vue?vue&type=script&lang=js"
import style0 from "./SettingsRoles.vue?vue&type=style&index=0&id=314b5b26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "314b5b26",
  null
  
)

export default component.exports